import React from "react";
import "./Section4.css";

const Section4 = () => {
  return (
    <section className="section4-hdt">
      <div className="section4-container-hdt">
        <div className="section4-grid-hdt">
          <div className="section4-left-hdt">
  <div className="section4-tag-hdt">
    <span>Ce qu’ils disent</span>
    <span className="section4-tag-line-hdt"></span>
  </div>

  <h2 className="section4-title-hdt">
    Ce que nos clients
    <br />
    <span>disent de nous</span>
  </h2>

  <div className="testimonial-card-hdt">
    <div className="quote-mark-hdt">”</div>

    <div className="testimonial-user-hdt">
      <div className="testimonial-avatar-hdt">
        <img
          src="/images/dollarstore.jpg"
          alt="Afi Mensah"
        />
      </div>

      <div className="testimonial-user-info-hdt">
        <h4>Afi Mensah</h4>
        <p>Cliente fidèle</p>
      </div>
    </div>

    <div className="testimonial-divider-hdt"></div>

    <p className="testimonial-text-hdt">
      “J’apprécie vraiment ce supermarché parce que j’y retrouve une grande
      variété de produits américains de qualité. Le service est excellent,
      l’accueil est chaleureux et je trouve facilement mes marques préférées
      à chaque visite.”
    </p>

    <div className="testimonial-stars-hdt">★★★★★</div>
  </div>
</div>

          <div className="section4-right-hdt">
            <div className="mosaic-hdt">
              <div className="mosaic-outline-hdt mosaic-outline-top-hdt"></div>
              <div className="mosaic-outline-hdt mosaic-outline-mid-hdt"></div>

              <div className="mosaic-cell-hdt cell-1-hdt">
                <img
                  src="/images/m5.webp"
                  alt="Lake destination"
                />
              </div>
              <div className="mosaic-cell-hdt cell-2-hdt">
                <img
                  src="/images/m6.webp"
                  alt="Lake destination"
                />
              </div>
              <div className="mosaic-cell-hdt cell-3-hdt">
                <img
                  src="/images/m7.jpg"
                  alt="Sky destination"
                />
              </div>
              <div className="mosaic-cell-hdt cell-4-hdt">
                <img
                  src="/images/m4.png"
                  alt="Island destination"
                />
              </div>

              <div className="mosaic-cell-hdt cell-5-hdt">
                <img
                  src="/images/m1.webp"
                  alt="Water destination"
                />
              </div>
              <div className="mosaic-cell-hdt cell-6-hdt">
                <img
                  src="/images/m2.jpg"
                  alt="Water destination"
                />
              </div>
              <div className="mosaic-cell-hdt cell-7-hdt">
                <img
                  src="/images/m3.avif"
                  alt="Traveler on boat"
                />
              </div>
              <div className="mosaic-cell-hdt cell-8-hdt">
                <img
                  src="/images/vs.png"
                  alt="Sea destination"
                />
              </div>
              <div className="mosaic-cell-hdt cell-9-hdt">
                <img
                  src="/images/lacolor.webp"
                  alt="Sea destination"
                />
              </div>

              <div className="mosaic-cell-hdt cell-10-hdt">
                <img
                  src="/images/spring.png"
                  alt="Ocean"
                />
              </div>
              <div className="mosaic-cell-hdt cell-11-hdt">
                <img
                  src="/images/corn.jpg"
                  alt="Boat center"
                />
              </div>
              <div className="mosaic-cell-hdt cell-12-hdt">
                <img
                  src="/images/equate.png"
                  alt="Ocean"
                />
              </div>
              <div className="mosaic-cell-hdt cell-13-hdt">
                <img
                  src="/images/la.webp"
                  alt="Ocean"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Section4;